var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConLabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 46.268,
    fill: "#336DCF",
    opacity: 0.102,
    rx: 46.5,
    ry: 46.005
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4764CD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.133 54.096V35.484c0-2.66-1.911-4.964-4.43-5.14-2.866-.267-5.384 2.038-5.384 4.963v18.79c0 3.101-3.561 4.076-2.519 9.217.608 3.013 2.953 5.495 5.906 6.027 4.777.975 9.119-2.748 9.119-7.623 0-4.254-2.692-4.697-2.692-7.622zm-8.077-18.79c0-1.86 1.563-3.367 3.474-3.19 1.65.088 2.866 1.595 2.866 3.368v8.774h-6.34v-8.951zm1.997 32.35c-2.258-.443-4.082-2.304-4.603-4.697-.868-4.431 2.606-4.963 2.606-8.863v-8.065h6.34v8.065c0 3.723 2.692 3.989 2.692 7.711 0 3.722-3.3 6.559-7.035 5.85zM41.805 26.975H27.996c-2.258 0-3.82 1.773-3.82 3.723s1.475 3.81 3.82 3.81v27.565c0 3.9 3.127 7.002 6.861 7.002 3.735 0 6.861-3.191 6.861-7.002V34.509c2.345 0 3.822-1.773 3.822-3.723.087-2.038-1.477-3.81-3.735-3.81zm-1.737 35.098c0 2.925-2.345 5.23-5.124 5.23-2.779 0-5.124-2.394-5.124-5.23v-3.014h3.127c.52 0 .868-.354.868-.886s-.347-.886-.868-.886h-3.214v-3.368h3.214c.52 0 .868-.355.868-.886 0-.532-.347-.887-.868-.887h-3.214v-3.368h3.214c.52 0 .868-.354.868-.886s-.347-.886-.868-.886h-3.214V42.84h3.214c.52 0 .868-.354.868-.886s-.347-.886-.868-.886h-3.214v-6.56h10.335v27.565zm1.824-29.337h-14.07c-1.041 0-1.997-.886-1.997-2.038 0-1.152.956-1.95 1.998-1.95h14.07c1.041 0 1.997.886 1.997 2.038 0 1.153-.869 1.95-1.998 1.95z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EAF0FA",
    d: "M70.37 34.254l-6.706-11.368-6.683 11.368a8.105 8.105 0 0 0-1.106 4.079c0 4.383 3.503 7.946 7.813 7.946s7.812-3.563 7.812-7.946c-.023-1.5-.415-2.907-1.13-4.079z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4764CD",
    d: "M70.721 34.561L63.977 23.17l-6.722 11.391a8.1 8.1 0 0 0-1.112 4.087c0 4.392 3.523 7.962 7.857 7.962s7.857-3.57 7.857-7.962c-.023-1.503-.417-2.912-1.136-4.087zM74 38.648c0 5.56-4.473 10.093-10 10.093s-10-4.533-10-10.093c0-1.83.49-3.586 1.407-5.165l6.722-11.391c.827-1.402 2.865-1.404 3.694-.003l6.738 11.379c.917 1.505 1.41 3.282 1.439 5.18zm-13.256-4.5v1.438h2.521v2.58h1.42v-2.58h2.571v-1.439H64.71v-2.58h-1.42v2.58h-2.546zm.173 5.346v1.362h6.166v-1.362h-6.166z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConLabs);
export default __webpack_public_path__ + "static/media/con-labs.8b64e63c85a19496cfca0ea35066e1d8.svg";
export { ForwardRef as ReactComponent };